import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from 'contexts/ThemeContext';

import numeral from 'utils/numeral';

import { Text } from 'components/DataDisplay';
import { Container, Item } from 'components/Layout';

const BillingLead = ({ label, amount, isTotal }) => {
  const { themeColors } = useTheme();
  const { designSystem } = themeColors;
  const weight = isTotal ? 700 : 400;

  return (
    <Item
      flex
      style={{
        alignItems: 'baseline',
        gap: '8px',
        ...(isTotal
          ? {
              backgroundColor: designSystem.bgSoft,
              borderRadius: '6px',
              padding: '9px 12px',
              marginTop: '3px'
            }
          : {})
      }}
    >
      <Text
        component="span"
        fontSize="13px"
        fontWeight={weight}
        style={{ color: isTotal ? designSystem.ink : designSystem.inkSoft }}
      >
        {label}
      </Text>
      <Item
        flex
        style={{
          flex: 1,
          borderBottom: `1.5px dotted ${designSystem.leaderDot}`,
          transform: 'translateY(-4px)'
        }}
      />
      <Text
        component="span"
        fontSize="13px"
        fontWeight={weight}
        style={{ color: designSystem.ink, whiteSpace: 'nowrap' }}
      >
        {numeral(amount).format('0,0 $')}
      </Text>
    </Item>
  );
};

BillingLead.defaultProps = {
  isTotal: false
};

BillingLead.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isTotal: PropTypes.bool
};

export const RecapBillingCard = ({ version }) => {
  const { themeColors } = useTheme();
  const { designSystem } = themeColors;

  if (!version) {
    return null;
  }

  const billingLines = [
    ...(version.lines || []),
    { label: 'Total HT', amount: version.totalHT, isTotal: true }
  ];

  return (
    <Container
      flex
      style={{
        width: '100%',
        boxSizing: 'border-box',
        flexDirection: 'column',
        alignItems: 'stretch',
        border: `1px solid ${designSystem.line}`,
        borderRadius: '10px',
        padding: '14px 16px',
        marginBottom: '12px'
      }}
    >
      <Text
        component="span"
        fontSize="12.5px"
        fontWeight={700}
        style={{ color: designSystem.inkSoft, marginBottom: '11px' }}
      >
        Facturation
      </Text>
      <Item
        flex
        style={{
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: '9px'
        }}
      >
        {billingLines.map(line => (
          <BillingLead
            key={line.label}
            label={line.label}
            amount={line.amount}
            isTotal={line.isTotal}
          />
        ))}
      </Item>
    </Container>
  );
};

RecapBillingCard.propTypes = {
  version: PropTypes.shape()
};

RecapBillingCard.defaultProps = {
  version: null
};

export default RecapBillingCard;
